import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  container: {
    paddingHorizontal: 16,
    paddingTop: 16,
  },
  scrollViewContainerStyle: withTray => ({
    paddingVertical: 16,
    paddingBottom: withTray ? 110 : 30,
  }),
  headerTitle: theme => ({
    fontWeight: 'bold',
    fontSize: 24,
    lineHeight: 30,
    color: theme.colors.headerColor,
  }),
  headerSubTitle: theme => ({
    fontSize: 16,
    color: theme.colors.headerColor,
    marginRight: 8,
    lineHeight: 20,
    marginTop: 8,
    marginBottom: 16,
  }),
  errorContainer: {
    height: 'auto',
    marginTop: 40,
  },
  errorIcon: {
    marginTop: 0,
  },
});
